import { ACTS } from "./timeline/acts";
import { TIMELINE_LABELS } from "./timeline/labels";
import { SHOT_CHECKPOINTS } from "./timeline/checkpoints";
import { installSiteQaApi } from "./qa/siteQaApi";
import { installAccountLinks } from "./account-links";
import { installAccountEntry } from "./account-entry";
import { installMarketingRegionRouting } from "./region-routing";
import { installTrialEntry } from "./trial-entry";
import { installAnalytics } from "./analytics";

export interface TimelineContract {
  acts: typeof ACTS;
  labels: typeof TIMELINE_LABELS;
  shotCheckpoints: typeof SHOT_CHECKPOINTS;
}

declare global {
  interface Window {
    __BB_TIMELINE_CONTRACT__?: TimelineContract;
  }
}

export function createTimelineContract(): TimelineContract {
  return {
    acts: ACTS,
    labels: TIMELINE_LABELS,
    shotCheckpoints: SHOT_CHECKPOINTS,
  };
}

export function attachTimelineContract(target: Window): TimelineContract {
  const contract = createTimelineContract();
  target.__BB_TIMELINE_CONTRACT__ = contract;
  return contract;
}

if (typeof window !== "undefined") {
  installAccountLinks(window);
  // После account-links: тот приводит ссылку к своему контуру, этот решает,
  // «Войти» на ней написано или «Мой аккаунт».
  installAccountEntry(window);
  installTrialEntry(window);
  installMarketingRegionRouting(window);
  attachTimelineContract(window);
  installSiteQaApi(window);
  installAnalytics(window);
}
